<template>
  <b-card>
    <h5><feather-icon icon="UsersIcon" /> fila: 100</h5>
    <h5>Contatados: 50</h5>
    {{ value }}
    <h3>Filtros</h3>

    <b-row>
      <b-col>
        <b-form-group>
          <v-select
            v-model="selected"
            label="e-commerce"
            :options="option"
          />
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <v-select
            v-model="selected"
            label="Status"
            :options="option"
          />
        </b-form-group>
      </b-col>

      <b-col>
        <div>
          <label for="example-datepicker">Escolha o Período</label>
          <b-form-datepicker
            id="example-datepicker"
            v-model="value"
            class="mb-1"
          />
        </div>
      </b-col>

    </b-row>

    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      block
      variant="primary"
    >
      Filtrar
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BAvatar, BBadge, BButton, BFormGroup,
  BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BBadge,
    BAvatar,
    BButton,
    BFormGroup,
    vSelect,
    BFormDatepicker,
  },
  data() {
    return {
      selected: { title: 'Square' },
      selected1: {
        title: 'Aperture',
        icon: 'ApertureIcon',
      },
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
      value: 'teste',
      codeBasic,
      codeBasic,
    }
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
